<template lang="pug">
.content
  .row
    .col-md-12
      div.box_header
        label.title Quản lý giáo án - Video
        label.title-pc(v-if="$isMobile()") {{lstPC.name}} / Quản lý giáo án video
        label.plus(v-on:click="doItemAdd")
          a
            span  Thêm giáo án Video
        label.title-pc(v-if="!$isMobile()") {{lstPC.name}} / Quản lý giáo án video
        .clearfix
      div.box-table(v-if="!$isMobile()" style="max-height: 385px; overflow-y: scroll;" v-on:scroll.passive='handleScroll')
        clTable(:centerColumns="['name', 'categories', 'action', 'classes']" :classes_id="filterclasses" @onfilterbycategories="filterbycategories" @onfilterbyclasses="filterbyclasses" @onfilterbyname="filterbyname" :data='lessons' :columns='columns' :inlineFilter='true' :filterCategories="categories" :filterClasses="classes" v-on:onQuestionCount='onQuestionCount', v-on:onItemEdit="onItemEdit")
      div.card.box-classes(v-else)
        .row-header
          span.label-header Tên video
          .field-header
            input(@change="filterbynameX($event)" placeholder="Tìm theo tên")
        .row-header
          span.label-header Danh mục
          .field-header
            select(@change="filterbycategoriesX($event)")
              option( value='') Tất cả
              option(v-for='o in categories' :value='o.id') {{o.name}}
        .row-header
          span.label-header Lớp học
          .field-header
            select(@change="filterbyclassesX($event)")
              option( value='') Tất cả
              option(v-for='o in classes' :value='o.id' :selected="filterclasses !== '' && filterclasses === o.id") {{o.name}}
        div.empty-data(v-if='this.lessons.length === 0') 
          span Không tìm thấy dữ liệu

        div.list-item(v-else style="overflow-y: scroll;" v-on:scroll.passive='handleScrollX')
          .row-item(v-for='(item, index) in lessons')
            .row-data.row-img
              .row-value.title
                img(:src="item.thumbnail" v-if="item.thumbnail && item.thumbnail !== null && item.thumbnail.length > 0")
                img(src="../../../assets/images/faces/ic_AvatarDefault@2x.png" v-else)
                span {{item.lesson.name}}
            .row-data
              span.label-header Danh mục:
              .row-value {{item.lesson.category.name}}
            .row-data
              span.label-header SL hỏi đáp:
              .row-value.link(@click="onQuestionCount(item)") 0
            .row-data
              span.label-header Lớp học:
              .row-value {{item.class.name}}
            .row-data
              span.label-header
              .row-value.float-right
                small(@click="onItemEdit(item)")
                  img(:src="require('../../../assets/images/faces/ic_edit.svg')")
                small(@click="onExpand(item)")
                  img(v-if="!lstOpen.includes(item.lesson_id + '_' + item.class_id)" :src="require('../../../assets/images/theory/ic_moreinformation@2x.png')")
                  img(v-if="lstOpen.includes(item.lesson_id + '_' + item.class_id)" :src="require('../../../assets/images/theory/ic_lessinformation@2x.png')")
            .row-data(v-if="lstOpen.includes(item.lesson_id + '_' + item.class_id)")
              span.label-header Ngày thêm mới:
              .row-value {{formatDate(item.created_at)}}
            .row-data(v-if="lstOpen.includes(item.lesson_id + '_' + item.class_id)")
              span.label-header Hẹn ngày:
              .row-value {{formatDate(item.start_date)}}
          
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import clTable from './clTable'
import moment from 'moment'
export default {
  components: {
    clTable,
    MdNotification
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      lessons: [],
      columns: [
        { key: 'stt', title: 'STT', width: '50px' },
        { key: 'img', title: 'Video', type: 'image', width: '65px' },
        { key: 'name', title: 'Tên video', type: 'lesson_name' },
        { key: 'categories', title: 'Danh mục', type: 'categories_name', width: '120px' },
        { key: 'question', title: 'SL hỏi đáp', type: 'question_count', width: '90px' },
        { key: 'classes', title: 'Lớp học', type: 'classes_name', width: '90px' },
        { key: 'created_at', title: 'Ngày thêm mới', type: 'date', width: '70px' },
        { key: 'start_date', title: 'Hẹn ngày', type: 'date', width: '70px' },
        { key: 'action', title: '', type: 'action', width: '50px' }
      ],
      limit: 10,
      offset: 0,
      lstPC: [],
      classes: [],
      categories: [],
      filtername: '',
      filterclasses: 0,
      filtercategories: 0,
      MdNotification,
      lstOpen: [],
      itemActive: null,
      isClose: false
    }
  },
  mounted () {
    if (this.$route.params.reload === 1) {
      console.log('reload')
      this.$apollo.queries.lessons.refresh()
    }
  },
  watch: {
    '$route': function(from, to) {
      if (from !== to) this.$apollo.queries.lessons.refresh()
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    formatDate(value) {
      if (value !== null) {
        return moment(value).format('DD/MM/YYYY - HH:mm')
      }
    },
    doItemAdd() {
      this.$router.push({name: 'lesson_planning_video_add', query: {id: this.lstPC.id}})
    },
    onItemEdit(payload) {
      this.$router.push({name: 'video_edit', params: {id: payload.class.pc_id, lesson_id: payload.lesson_id, lesson_planning_pc_id: this.$route.query.id}})
    },
    onQuestionCount(payload) {
      this.showNotification(this.message, 'warning', 'top', 'right', 7000)
    },
    handleScroll: function(e) {
      if ((e.target.scrollHeight - 385) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 385) === Math.floor(e.target.scrollTop)) {
        this.limit = this.lessons.length + 10
      }
    },
    handleScrollX: function(e) {
      if ((e.target.scrollHeight - 538) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 538) === Math.floor(e.target.scrollTop)) {
        this.limit = this.lessons.length + 5
      }
    },
    filterbyname(valueName) {
      this.filtername = ''
      if (valueName !== '') {
        this.filtername = valueName
      }
      this.$apollo.queries.lessons.refetch()
    },
    filterbycategories(valueCatgories) {
      this.filtercategories = ''
      if (valueCatgories !== '') {
        this.filtercategories = parseInt(valueCatgories)
      }
      this.$apollo.queries.lessons.refetch()
    },
    filterbyclasses(valueClasses) {
      this.filterclasses = ''
      if (valueClasses !== '') {
        this.filterclasses = parseInt(valueClasses)
      }
      this.$apollo.queries.lessons.refetch()
    },
    filterbynameX(event) {
      var valueName = event.target.value
      this.filtername = ''
      if (valueName !== '') {
        this.filtername = valueName
      }
      this.$apollo.queries.lessons.refetch()
    },
    filterbycategoriesX(event) {
      var valueCategories = event.target.options[event.target.options.selectedIndex].value
      this.filtercategories = ''
      if (valueCategories !== '') {
        this.filtercategories = parseInt(valueCategories)
      }
      this.$apollo.queries.lessons.refetch()
    },
    filterbyclassesX(event) {
      var valueClasses = event.target.options[event.target.options.selectedIndex].value
      this.filterclasses = ''
      if (valueClasses !== '') {
        this.filterclasses = parseInt(valueClasses)
      }
      this.$apollo.queries.lessons.refetch()
    },
    onExpand(item) {
      if (this.lstOpen.indexOf(item.lesson_id + '_' + item.class_id) === -1) this.lstOpen.push(item.lesson_id + '_' + item.class_id)
      else this.lstOpen.splice(this.lstOpen.indexOf(item.lesson_id + '_' + item.class_id), 1)
    }
  },
  apollo: {
    lessons: {
      query: gql(graphql.GET_LESSON_PLANING_CLASSES_OF_PC),
      fetchPolicy: 'no-cache',
      variables() {
        let objLesson = {
          is_delete: {_eq: false},
          type_lesson: {_eq: 2}
        }
        let objWhere = {
          class: {
            pc_id: {_eq: this.$route.query.id},
            private_community: {user_id: {_eq: this.$store.getters.user}}
          }
        }
        if (this.$route.params.classes_id !== undefined && this.$route.params.classes_id !== null) {
          this.filterclasses = this.$route.params.classes_id
        }
        if (this.filtername !== '') {
          objLesson = Object.assign(objLesson, {name: {_ilike: '%' + this.filtername + '%'}})
        }
        if (this.filtercategories !== '' && this.filtercategories > 0) {
          objLesson = Object.assign(objLesson, {category_id: {_eq: this.filtercategories}})
        }

        if (this.filterclasses !== '' && this.filterclasses > 0) {
          objWhere = Object.assign(objWhere, {class_id: {_eq: this.filterclasses}})
        }
        objWhere = Object.assign(objWhere, {lesson: objLesson})
        let variables = {
          where: objWhere,
          limit: this.limit,
          orderBy: {created_at: 'desc'}
        }
        return variables
      },
      update: data => {
        return data.lesson_class
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    },
    lstPC: {
      query: gql(graphql.GET_PC_OF_USER),
      fetchPolicy: 'no-cache',
      variables() {
        return {
          where: {
            user_id: {_eq: this.$store.getters.user},
            id: {_eq: this.$route.query.id}
          }
        }
      },
      update: data => {
        return data.private_community[0]
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    },
    categories: {
      query: gql(graphql.GET_CATEGORY),
      fetchPolicy: 'no-cache',
      update: data => {
        return data.category
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    },
    classes: {
      query: gql(graphql.GET_CLASSES_OF_PC),
      fetchPolicy: 'no-cache',
      variables() {
        return {
          where: {
            pc_id: {_eq: this.$route.query.id},
            is_delete: {_eq: false}
          }
        }
      },
      update: data => {
        return data.classes
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.box_header {
  label.title{ text-align: left; font-size:20px;  font-weight:bold;font-family: 'adobe-clean', sans-serif; letter-spacing: 0px;color: #5F6468;display:inline-block}
  label.title-pc{display: block;margin-top: 10px; color: #343A40; font-size: 16px;}
  label.plus{background: #FFD311 0% 0% no-repeat padding-box;border-radius: 5px; padding: 12px 40px;cursor: pointer; float:right}
  label.minus{ background: #FFD311 0% 0% no-repeat padding-box; border-radius: 5px; padding: 12px 40px; cursor: pointer;  float: left;}
  span{ text-align: center; font: Regular 14px;letter-spacing: 0px;color: #23180A;}
}
.box-table{ background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 1px 3px #00000029; padding:10px; margin-top:20px;border-radius: 10px;
  input, select{border-radius: 10px !important;}
}
.list-action {cursor: pointer;}
.box-popup-confirm{box-shadow: 0px 3px 6px #00000029; border-radius: 10px !important;
  .dialog-content{ padding: 0;
    .dialog-c-title {text-transform: uppercase; text-align: left;font-size:17px; font-family: Helvetica;letter-spacing: 0px;color: #343A40; border-bottom: 1px solid #DFE2E6; padding: 12px 15px 15px; font-weight: bold; margin-bottom: 15px;}
    .dialog-c-text{padding: 0 15px;}
  }
  .vue-dialog-buttons {justify-content: center;display: flex; border: 0! important; margin-top: 30px; margin-bottom: 5px;
    .confirm-delete-dialog {background: #FFD311 0% 0% no-repeat padding-box! important;border-radius: 5px; width: 160px;color: #23180A! important;margin-right: 10px;flex: unset! important;}
    .cancel-delete-dialog, .cancel-delete-dialog:hover {background: #FFFFFF 0% 0% no-repeat padding-box! important;border: 1px solid #FFD311;border-radius: 5px;width: 160px;color: #23180A! important;flex: unset! important;}
  }
}
.box-classes{
  input, select{border-radius: 10px;}
}

@media screen and (min-width: 768px){
  .vue-dialog {
    width: 500px! important;
  }
}
@media screen and (max-width: 991px){
  .box_header{
    label.title{display: block;}
    label.plus{display: inline-block;float: none;margin-top: 15px;}
    label.title-pc{display: block;}
  }
  .box-classes{background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029; padding: 15px;border-radius: 10px;
    .row-header{border: 1px solid #E0E0E0;border-top: 0;background: #FAFAFA 0% 0% no-repeat padding-box; 
      .label-header{display: inline-block; line-height: 30px;width: 40%;font-weight: bold;text-align: right; padding-right: 10px;}
      .field-header{padding: 3px 10px; display: inline-block; width: 60%; background: #EAEAEA 0% 0% no-repeat padding-box;
        input, select{width: 100%;border-radius: 10px; padding: 3px 10px; background: #fff;border: 1px solid #B4B4B4; border-radius: 10px;}
      }
       &:first-child{border-top: 1px solid #E0E0E0; border-top-left-radius: 10px; border-top-right-radius: 10px; overflow: hidden;}
      &:nth-child(3){ border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; overflow: hidden;}
    }
    input, select{border-radius: 10px !important;}
    .empty-data{margin-top: 20px; background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 10px; text-align: center; padding: 5px;}
    .list-item{margin-top: 20px;
      .row-item{background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 10px; padding: 7px 5px; margin-bottom: 10px;
        &:first-child{margin-bottom: 10px;}
        .row-data{
          &.row-img{display: flex; align-items: center;
            .row-value{ width: 100%;
              img{width: auto; margin-right: 10px; border-radius: 10px; max-height: 64px; max-width: 64px;}
            }
          }
          .label-header{display: inline-block; width: 40%;color: #969FAD;text-align: left;}
          .row-value{padding: 3px 0; display: inline-block; width: 60%; color: #333;
            &.title{font-size: 15px; font-weight: bold; margin-bottom: 15px;display: flex; color: #9F6A28;}
            &.link{text-decoration: underline; color:#554BC1;}
            select{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;width: 100%;}
            small{margin-right: 10px; float: left;
              &:last-child{margin-right: 0;}
              img{width: 16px;height: 16px;}
            }
            img.img{border-radius: 50%;width: 30px; height: 30px;}
            &.float-right{
              small{float: right;margin-left: 10px;}
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px){
  .box_header{
    label.title{display: block;}
    label.plus{display: inline-block;float: none;margin-top: 15px;}
    label.title-pc{display: block;}
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?2f58f14a